import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wearesocial',
  templateUrl: './wearesocial.component.html',
  styleUrls: ['./wearesocial.component.css']
})
export class WearesocialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
